import { render, staticRenderFns } from "./SettingIndex.vue?vue&type=template&id=4a493a61&scoped=true&"
import script from "./SettingIndex.vue?vue&type=script&lang=js&"
export * from "./SettingIndex.vue?vue&type=script&lang=js&"
import style0 from "./SettingIndex.vue?vue&type=style&index=0&id=4a493a61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a493a61",
  null
  
)

export default component.exports